import api from './api';
import { ApiResponse } from '../types';

export interface Category {
  id: string;
  name: string;
  displayName: string;
  isActive: boolean;
  displayOrder: number;
  createdAt: string;
  updatedAt: string;
}

class CategoryService {
  async getCategories(): Promise<Category[]> {
    const response = await api.get<ApiResponse<Category[]>>('/categories');
    return response.data.data;
  }
}

export default new CategoryService();